var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper-content w-100",attrs:{"id":"codificator-builder-new-or-edit"}},[_c('p',[_vm._v("Componente en estado de prueba")]),(_vm.component)?_c(_vm.component.label,{tag:"Component",on:{"input":function($event){return _vm.$emit('input', $event)}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }